import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Typography, Paper } from "@mui/material";
import HealthWidget from "./HealthWidget";
import MessageStatsWidget from "./MessageStatsWidget";
import BlockStatsWidget from "./BlockStatsWidget";
import WarmUpWidget from "./WarmUpWidget";
import DailyLimitsWidget from "./DailyLimitsWidget";
import AgentPerformanceWidget from "./AgentPerformanceWidget";
import ContactHealthWidget from "./ContactHealthWidget";
import AlertsWidget from "./AlertsWidget";
import TipsWidget from "./TipsWidget";

const AUTH_API = process.env.REACT_APP_AUTH_API || "/api/auth";
const BASE = AUTH_API.replace("/api/auth", "");

function headers() {
  const token = localStorage.getItem("admin_token");
  return { "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) };
}

export default function MonitoringDashboard({ clientId }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    fetch(`${BASE}/api/dashboard/all`, { headers: headers() })
      .then(res => {
        if (!res.ok) throw new Error("Failed to load dashboard");
        return res.json();
      })
      .then(setData)
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, [clientId]);

  if (loading) return <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}><CircularProgress /></Box>;
  if (error) return <Paper sx={{ p: 3, textAlign: "center", color: "#ef4444" }}>{error}</Paper>;
  if (!data) return null;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "27px" }}>
      <Paper className="glass-card" sx={{ p: 3, bgcolor: "linear-gradient(135deg, rgba(99,102,241,0.08) 0%, rgba(139,92,246,0.08) 100%)" }}>
        <Typography fontWeight={800} fontSize={20} color="#1e293b" mb={0.5}>Monitoring Dashboard</Typography>
        <Typography variant="body2" color="#64748b">Real-time account health, message stats, and ban prevention insights</Typography>
      </Paper>

      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: "27px" }}>
        <HealthWidget data={data.health} />
        <BlockStatsWidget data={data.blocks} />
      </Box>

      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr" }, gap: "27px" }}>
        <MessageStatsWidget data={data.messages} />
        <WarmUpWidget data={data.warmup} />
        <DailyLimitsWidget data={data.limits} />
      </Box>

      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: "27px" }}>
        <AgentPerformanceWidget data={data.agents} />
        <ContactHealthWidget data={data.contacts} />
      </Box>

      <AlertsWidget alerts={data.alerts} />
      <TipsWidget tips={data.tips} />
    </Box>
  );
}
